module.exports = __webpack_public_path__ + "img/EATON.d7ee8d16.png";